"use client";
import React, { useEffect, useRef } from "react";
import styles from "./DmsFinalCta.module.css";

export default function DmsFinalCtaSection() {
  const cardRef = useRef(null);

  useEffect(() => {
    const card = cardRef.current;
    if (!card) return;

    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add(styles.inView)),
      { threshold: 0.2 }
    );
    obs.observe(card);
    return () => obs.disconnect();
  }, []);

  return (
    <section className={`${styles.section} py-5`}>
      <div className={styles.wrap}>
        <div ref={cardRef} className={styles.card} data-reveal="fade">
          <div className={styles.particles} aria-hidden></div>

          <header className={styles.head}>
            <div className={styles.eyebrow}>Final Call-to-Action</div>
            <h3 className={styles.title}>Ready to Digitize Your Document Workflow?</h3>
            <p className={styles.subtitle}>
              Talk to our experts and discover how CodeQlik’s DMS can save hours every week, boost compliance, and unlock
              efficiency across your teams.
            </p>
          </header>

          <div className={styles.actions}>
            <a href="#book-demo" className={`${styles.btn} ${styles.btnPrimary}`}>
              <i className="fa-solid fa-phone"></i>
              Book a Free Demo
            </a>
            <a href="#get-consultation" className={`${styles.btn} ${styles.btnSecondary}`}>
              <i className="fa-solid fa-envelope"></i>
              Get a Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
